import React from 'react'
import SvgPrint from './icons/SvgPrint'

export interface PrintButtonProps {
	documentClassName?: string 
}

export const PrintButton: React.FunctionComponent<PrintButtonProps> = ({
	children, documentClassName
}) => {
	return (
		<button
			type="button"
			className="printButton"
			onClick={() => {

				if(documentClassName)
				{
					document.body.classList.add(documentClassName); 	
				}
				
				window.print();

				if(documentClassName)
				{
					document.body.classList.remove(documentClassName); 	
				}
				
			}}
		>
			<span className="printButton-icon">
				<SvgPrint />
			</span>
			{children}
		</button>
	)
}
